module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921125651_T.3fa547f7.jpg";